<template>
	<div>
		<div>
			<el-row>
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
						Total Data : <br>
						<span style="font-size:32px;">{{ (totalFbPrice) }}</span>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-button class="mb-10" style="background-color: #3576F2; color: #FFFFFF;" @click="dialogFormVisible = true">Add New Data</el-button>
					<el-button class="mb-10 ml-10" type="info" @click="synchronize()" :loading="loadingSync">
						<i class="mdi mdi-sync"></i> Synchronize
					</el-button>
				</el-col>
				<el-col style="text-align: right;" :span="12">
					<el-input
						class="search-customer mb-10 fl-l" style="width:auto;"
						prefix-icon="el-icon-search"
						placeholder="Search Country Name"
						clearable
						@keypress.native="doSearchFbPrice"
						@clear="doSearchFbPrice"
						@keyup.native="doSearchFbPrice"
						v-model="searchFbPrice">
					</el-input>
				</el-col>
			</el-row>
		</div>

		<template>
			&nbsp;
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateFbPrice"
				:current-page="currentPageRequest"
				:total="parseInt(totalFbPrice)"/>
			<br/>
			<el-table :data="reqFbPrice" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
				<!-- <el-table-column prop="dateCreate" label="Created At" width="200">
					<template slot-scope="props">
						<p style="font-weight:bold;">{{ formatDate(props.row.dateCreate, "DD/MM/YY HH:mm:ss") }}</p>
					</template>
				</el-table-column> -->
				<el-table-column prop="modelName" label="Price Model" width="150">
					<template slot-scope="props">
						<p style="font-weight:bold;">{{ props.row.modelName != null ? props.row.modelName : "-" }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="countryCode" label="Prefix" width="100">
					<template slot-scope="props">
						<p style="font-weight:bold;">{{ '+'+props.row.countryCode }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="domainName" label="Domain" width="100"/>
				<el-table-column prop="countryName" label="Country Name" width="400" />
				<el-table-column prop="price_bi" label="Price BI" width="180">
					<template slot-scope="props">
						<p style="font-weight:bold;">{{ formatPrice(props.row.price_bi) }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="price_ui" label="Price UI" width="180">
					<template slot-scope="props">
						<p style="font-weight:bold;">{{ formatPrice(props.row.price_ui) }}</p>
					</template>
				</el-table-column>
				<el-table-column
					fixed="right"
					label="Action"
					width="300">
					<template slot-scope="scope">
						<el-button size="small"  @click="detailFbPrice(scope.row)">Edit</el-button>
						<el-button size="small" type="danger" @click="deleteFbPrice(scope.row)">Delete</el-button>
					</template>
				</el-table-column>
			</el-table>
			&nbsp;
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateFbPrice"
				:current-page="currentPageRequest"
				:total="parseInt(totalFbPrice)"/>
			<br/>
		</template>

		<el-dialog :close-on-click-modal="false" title="Add Facebook Price" :visible.sync="dialogFormVisible">
            <el-form ref="form" label-width="180px">
                <el-form-item label="Price Model">
                    <template>
                        <el-row>
                            <el-col style="text-align: center;" :span="10">
                                <el-radio v-model="price_model" label="1">Default</el-radio>
                                <el-radio v-model="price_model" label="2">Custom</el-radio>
                            </el-col>
                            <el-col :span="14">
                                <el-input :disabled="price_model == '1' ? true: false" v-model="model_name" placeholder="-"></el-input>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Domain & Country Name">
                    <template>
                        <el-row>
                            <el-col :span="6">
                                <el-input :disabled="country_name == '' ? true: false" v-model="domain_name"></el-input>
                            </el-col>
                            <el-col :span="12">
                                <el-select style="width: 100%;" v-model="country_name" @change="handleChangeSelectedCountry" filterable placeholder="Select Country">
                                <el-option
                                v-for="(item) in countries" :key="item.countryCode"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn">
                                <div>
                                    <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                    <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                                </div>
                                </el-option>
                            </el-select>
                            </el-col>
                            <el-col :span="6">
                                <el-input readonly v-model="country_code" placeholder="-"></el-input>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Price BI">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'price_bi')" v-model="price_bi"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Price UI">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'price_ui')" v-model="price_ui"></el-input>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="addFacebookPrice" :loading="loadingBtn">Add</el-button>
                    <el-button @click="dialogFormVisible=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

		<el-dialog :close-on-click-modal="false" title="Edit Facebook Price" :visible.sync="dialogFormVisibleEdit">
            <el-form ref="form" label-width="180px">
                <el-form-item label="Price Model">
                    <template>
                        <el-row>
                            <el-col style="text-align: center;" :span="10">
                                <el-radio v-model="price_model_edit" label="1">Default</el-radio>
                                <el-radio v-model="price_model_edit" label="2">Custom</el-radio>
                            </el-col>
                            <el-col :span="14">
                                <el-input :disabled="price_model_edit == '1' ? true: false" v-model="editFbPrice.model_name" placeholder="-"></el-input>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Domain & Country Name">
                    <template>
                        <el-row>
                            <el-col :span="6">
                                <el-input :disabled="editFbPrice.country_name == '' ? true: false" v-model="editFbPrice.domain_name"></el-input>
                            </el-col>
                            <el-col :span="12">
                                <el-select style="width: 100%;" v-model="editFbPrice.country_name" @change="handleChangeSelectedCountryEdit" filterable placeholder="Select Country">
                                <el-option
                                v-for="(item) in countries" :key="item.countryCode"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn">
                                <div>
                                    <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                    <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                                </div>
                                </el-option>
                            </el-select>
                            </el-col>
                            <el-col :span="6">
                                <el-input readonly v-model="editFbPrice.country_code" placeholder="-"></el-input>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Price BI">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'editFbPrice','price_bi')" v-model="editFbPrice.price_bi"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Price UI">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'editFbPrice','price_ui')" v-model="editFbPrice.price_ui"></el-input>
                    </template>
                </el-form-item>

				<el-form-item label="Created By">
                    <template>
                        <el-input disabled v-model="editFbPrice.admin"></el-input>
                    </template>
                </el-form-item>

				<el-form-item label="Created At">
                    <template>
                        <el-input disabled :value="this.formatDate(editFbPrice.dateCreate, 'DD/MM/YYYY HH:mm:ss')"></el-input>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="editFacebookPrice" :loading="loadingBtn">Edit</el-button>
                    <el-button @click="dialogFormVisibleEdit=false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')
import CountryFlag from 'vue-country-flag'
const countryCodes = require('country-codes-list')

export default {
	name: 'Facebook_Price',
    props: {
        dataPrice: {
            type: Array
        },
        loadingData: {
            type: Boolean
        },
        // showAlert: {
        //     type: Boolean
        // },
        total: {
            type : Number
        }
    },
	data () {
		return {
			loadingSync: false,
			paginate: true,
			bodyStyle: {
				padding: "20px"
			},
			loadingSession: false,
			selectedStartDateSession: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            price_bi: 0,
            price_ui: 0,
            country_code: '',
            country_name: "",
            domain_name: '',
            countries: [],
			mapingCountries: [],
			reqFbPriceIdentity:[],
			price_model_identity:[{model:{modelName: "",countryName: "", domainName:""}}],
            model_name:"",
			maskingName: "",
            price_model: "1",
			price_model_edit: "1",
			editFbPrice: {},
			reqFbPrice: [],
			loadingTemplate: true,
			currentPage: 1,
			currentPageRequest: 1,
			totalFbPrice: 0,
			dialogFormVisible:false,
			dialogFormVisibleEdit:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			searchFbPrice:'',
			loadingApproved: false
		}
	},
    components: {
        CountryFlag
    },
	methods: {
		doSearchFbPrice(){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.getFbPrice()
			}, 1000)
		},
		find_duplicate_in_array(arra1, param) {
			var object = {};
			var result = [];

			arra1.forEach(function (item) {
			if(!object[item[param].countryName])
				object[item[param].countryName] = 0;
				object[item[param].countryName] += 1;
			})

			for (var prop in object) {
			if(object[prop] >= 2) {
				result.push(prop);
			}
			}

			return result;

		},
		addDataIdentity(){
			this.mapingCountries = this.countries
			this.dialogFormVisibleIdentity = true
		},
		addModel(){
			this.price_model_identity.push({model:{modelName: "",countryName: "", domainName:""}})
		},
		addModelEdit(){
			this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
		},
		deleteModel(i){
			this.price_model_identity.splice(i,1)
		},
		deleteModelEdit(i){
			this.editIdentity.price_model.splice(i,1)
		},
		formatType(val){
			let result = ""
			result = val.replace("_", " ").toUpperCase();
			return result ;
		},
		formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, field, field2 = undefined) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			console.log(field);
			console.log(FilteredChars);

			if (field2) {
				this[field][field2] = FilteredChars
			}
			else{
				this[field] = FilteredChars
			}
        },
		async handleChangeSelectedModel(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.price_model_identity[key].model.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedModelEdit(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.editIdentity.price_model[key].facebook_price.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedCountryModel(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.price_model_identity[key].model.modelName = ""
			this.price_model_identity[key].model.domainName = ""
			this.price_model_identity[key].model.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		async handleChangeSelectedCountryModelEdit(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.editIdentity.price_model[key].facebook_price.modelName = ""
			this.editIdentity.price_model[key].facebook_price.domainName = ""
			this.editIdentity.price_model[key].facebook_price.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		handleChangeSelectedIdentity(val){
			console.log(val);
			if (val == "waba_id" && this.editIdentity.price_model.length == 0) {
				this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
			}
		},
        handleChangeSelectedCountry(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.country_code = "+" + find.countryCallingCode
                this.domain_name = find.countryCode    
            }
            
        },
		handleChangeSelectedCountryEdit(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.editFbPrice.country_code = "+" + find.countryCallingCode
                this.editFbPrice.domain_name = find.countryCode    
            }
            
        },
		detailFbPrice(row){
			console.log('row selectd',row)
			this.editFbPrice = row
			this.editFbPrice.model_name = row.modelName
			this.price_model_edit = '2'

			if (!this.editFbPrice.model_name) {
				this.price_model_edit = '1'
			}
			this.editFbPrice.domain_name = row.domainName
			this.editFbPrice.country_code = "+"+row.countryCode
			this.editFbPrice.country_name = row.countryName
			this.editFbPrice.dateCreate = row.dateCreate
			this.dialogFormVisibleEdit = true
		},
		deleteFbPrice(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this price?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-price/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginateFbPrice()
						this.paginateFbPrice(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		readMore(text){
			if(text){
				if(text.length > 100) return text.substring(0, 100) + "..."
				else return text
			} else{
				return text
			}
		},
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async addFacebookPrice(){
			if(_.isEmpty(this.domain_name) || _.isEmpty(this.country_code) || _.isEmpty(this.country_name) || _.isEmpty(this.price_bi) || _.isEmpty(this.price_ui)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            if (this.price_model == '1') {
                this.model_name = ""
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-fb-price',
				method:'POST',
				data:{
					model_name:this.model_name,
					domain_name:this.domain_name,
					country_code:this.country_code,
					country_name:this.country_name,
                    price_bi: this.price_bi,
                    price_ui: this.price_ui
				}
			}).then(response => {
                this.dialogFormVisible = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.clear()
					this.paginateFbPrice()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisible = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
		},
		async editFacebookPrice(){
			console.log(this.editFbPrice);
			if(!this.editFbPrice.id){
                this.$message.error({
                    showClose: false,
                    message: 'Id is undefined'
                });
                return
            }

            if (this.price_model_edit == '1') {
                this.editFbPrice.model_name = ""
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/update-fb-price',
				method:'POST',
				data:{
					id: this.editFbPrice.id,
					model_name:this.editFbPrice.model_name,
					domain_name:this.editFbPrice.domain_name,
					country_code:this.editFbPrice.country_code,
					country_name:this.editFbPrice.country_name,
                    price_bi: this.editFbPrice.price_bi,
                    price_ui: this.editFbPrice.price_ui
				}
			}).then(response => {
                this.dialogFormVisibleEdit = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.paginateFbPrice()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleEdit = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				this.paginateFbPrice()
				return error
			})
		},
		async paginateFbPrice(page) {
			this.currentPageRequest = page
			await this.getFbPrice(page)
		},
		async synchronize(){
			this.loadingSync = true
			await api({
				url: config.baseApi+'bussiness/sync-fb-price',
				method: 'GET'
			}).then(({ data }) => {
				console.log(data);
				this.$swal(this.$t('success'), this.$t('success'), "success")
				this.loadingSync = false
			}).catch(error => {
				this.loadingSync = false
			})
		},
		async getFbPrice(page = 1){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-price',
				method: 'GET',
				params: {
					page: page,
					search: this.searchFbPrice
				}
			}).then(({ data }) => {
				console.log(data);
				data.data.data.forEach(element => {
					element.price_bi = Number(element.price_bi)
					element.price_ui = Number(element.price_ui)
				});
				console.log(data.data.data);
				this.reqFbPrice = data.data.data
                this.totalFbPrice = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async detailPrice(param){
			this.$router.push('business/' + param)
		},
		clear(){
			this.editFbPrice = {}
			this.price_model_identity = [{model:{modelName: "",countryName: "", domainName:""}}]
			this.price_bi = 0
            this.price_ui = 0
            this.country_code = ''
            this.country_name = ""
            this.domain_name = ''
            this.model_name =""
            this.price_model = "1",
			this.maskingName = ""
			this.identityNumber = ""
		}
	},
	watch: {
        dataPrice: function() {
            this.reqFbPrice = this.dataPrice
        },
        loadingData: function() {
           this.loadingTemplate = this.loadingData          
        },
        total: function() {
            this.totalFbPrice = this.total
        }
    },
	// async mounted(){
    //     // await this.paginateFbPrice()
    //     this.getFbIdentity()
	// 	this.getFbSession()
	// 	this.getFbPrice()
	// },
    created(){
        this.countries = countryCodes.all()
    }
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
